module.exports = __webpack_public_path__ + "static/media/service3.ba4c3558.jpg";